'use strict';

import Api from "./Api";

export default class ClientSubscription extends Api {

    static getList(page = 1, perPage = 10, sort = undefined, extraFields = []) {
        const url = this.url + 'client-subscription/list';

        return this.getAxios().get(url, {
            params: {
                page: page,
                'per-page': perPage,
                sort: sort,
                expand: extraFields.join(','),
            },
        });
    }

    static getListByClient(clientId) {
        const url = this.url + 'client-subscription/list-by-client';

        return this.getAxios().get(url, {
            params: {
                clientId: clientId,
            },
        });
    }

    static activate(id) {
        const url = this.url + 'client-subscription/activate';

        return this.getAxios().post(url, {
            id: id,
        });
    }

    static hide(id) {
        const url = this.url + 'client-subscription/hide';

        return this.getAxios().post(url, {
            id: id,
        });
    }

    static remove(id) {
        const url = this.url + 'client-subscription/remove';

        return this.getAxios().post(url, {
            id: id,
        });
    }

    static addCount(subscriptionId, count, sum, paymentType) {
        const url = this.url + 'client-subscription/add-count';

        return this.getAxios().post(url, {
            subscriptionId: subscriptionId,
            count: count,
            sum: sum,
            paymentType: paymentType,
        });
    }

    static addDays(subscriptionId, days, sum, paymentType) {
        const url = this.url + 'client-subscription/add-days';

        return this.getAxios().post(url, {
            subscriptionId: subscriptionId,
            days: days,
            sum: sum,
            paymentType: paymentType,
        });
    }

}
